module.exports = __webpack_public_path__ + "img/1507767783.5af9c696.jpg";